#import "./InvoiceFragment.graphql"

query InvoicesSigningSearch(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $first: Int
  $after: Cursor
  $orderBy: [InvoicesOrderBy!]
  $filter: InvoiceFilter
  $invoiceSigningSearchSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $isSearchAllData: Boolean
  $filterSupplierId: UUID
  $filterMultiStatusTypes: [Int]
) {
  invoiceSigningSearch(
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
    searchRequest: $invoiceSigningSearchSearchRequest
    isLinkSearch: $isLinkSearch
    isSearchAllData: $isSearchAllData
    filterSupplierId: $filterSupplierId
    filterMultiStatusTypes: $filterMultiStatusTypes
  ) {
    nodes {
      ...InvoiceFragment
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
